import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled } from '@ant-design/icons';
import { Modal, Col, Row, Table, Space, Button, Form, FormInstance, Select, Input } from 'antd';
import { AlignType } from 'rc-table/lib/interface';

import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { onlyNumbers } from "../../../utils/utilsFunctions";
import { ITelefonePessoaFisica } from "./InterfacePessoaFisica";
import { masktelefoneSemDdd } from "../../../utils/maskFunctions";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import { lista_tipoTelefone } from "../../../config/Contantes";
interface IProps {
  form: FormInstance<any>;
  telefones: ITelefonePessoaFisica[];
  setTelefones: React.Dispatch<React.SetStateAction<ITelefonePessoaFisica[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
}

const { Option } = Select;
const PessoaFisicaTelefone = ({ form, telefones, setTelefones, manter }: IProps) => {
  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo edição
  const [exibirModalPfTelefone, setExibirModalPfTelefone] = useState(false);
  const [exibirTelefoneCadastrado, setExibirTelefoneCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");

  const [csTipoTelefoneEmEdicao, setCsTipoTelefoneEmEdicao] = useState(0);

  useEffect(() => {
    if (telefones && telefones.length === 0) {
      setExibirTelefoneCadastrado("none")
    } else {
      setExibirTelefoneCadastrado("inline")
      setValoresAuxiliares();
    }
  }, [telefones]);

  const setValoresAuxiliares = (() => {
    telefones.forEach(telefone => {
      lista_tipoTelefone.forEach(e => {
        if (telefone.csTpTelefone === e.enum) {
          telefone.tipoTelefone = e.tipoTelefone
        }
      })
    })
  })

  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);

  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // PASSA O MODAL PARA O MODO EDIÇÃO
    }
  }, [estadoModal])


  const controleDaGrid = (botao: string) => {
    if (form.getFieldValue("nuCpf") === "") {
      mostrarInfo("Não é possível incluir novo telefone", "CPF ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalPfTelefone(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalPfTelefone(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalPfTelefone(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarTelefone = () => {
    const numFone = onlyNumbers(form.getFieldValue("nuTelefone"));
    if (!numFone) {
      errorMessage("O campo telefone é obrigatório");
    } else if (csTipoTelefoneEmEdicao > 10 && numFone.length !== 8) {
      errorMessage("O campo telefone deve ter 8 números para telefone fixo");
    } else if (csTipoTelefoneEmEdicao < 10 && numFone.length !== 9) {
      errorMessage("O campo telefone deve ter 9 números para telefone celular");
    } else if (form.getFieldValue("csTpTelefone") < 10 && (form.getFieldValue("nuRamal") !== undefined && form.getFieldValue("nuRamal") !== "")) {
      errorMessage("O campo ramal não dever ser preenchido para um celular");
    } else {
      form
        .validateFields([
          "csTpTelefone",
          "tipoTelefone",
          "nuDddTelefone",
          "nuTelefone",
          "nuRamal",
        ])
        .then(() => {
          controleDaGrid("incluir");
          setDadosTelefone();
          // successMessage(estadoModal === 3 ? "Telefone Alterado" : "Telefone Adicionado");

        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido");
        });
    }
  };

  function setDadosTelefone() {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setTelefones(pre => {
        return pre.map(tel => {
          if (tel.emEdicao) {
            return ({
              idPessoaFisicaTelefone: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaTelefone")) : -1,
              csTpTelefone: form?.getFieldValue("csTpTelefone"),
              tipoTelefone: form?.getFieldValue("tipoTelefone").toUpperCase(),
              nuDddTelefone: form?.getFieldValue("nuDddTelefone"),
              numeroTelefone: form?.getFieldValue("nuTelefone"),
              nuTelefone: onlyNumbers(form?.getFieldValue("nuTelefone")),
              nuRamal: form?.getFieldValue("nuRamal"),
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return tel
          }
        })
      });
    } else {
      setTelefones([
        ...telefones,
        {
          idPessoaFisicaTelefone: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaTelefone")) : -1,
          csTpTelefone: form?.getFieldValue("csTpTelefone"),
          tipoTelefone: form?.getFieldValue("tipoTelefone"),
          nuDddTelefone: form?.getFieldValue("nuDddTelefone"),
          numeroTelefone: form?.getFieldValue("nuTelefone"),
          nuTelefone: onlyNumbers(form?.getFieldValue("nuTelefone")),
          nuRamal: form?.getFieldValue("nuRamal"),
          statusReg: 1,
          emEdicao: false,
          touched: true
        },
      ]);
    }

    form.resetFields([
      "csTpTelefone",
      "tipoTelefone",
      "nuDddTelefone",
      "nuTelefone",
      "nuRamal",
    ]);
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const handlerTipoTelefone = async (value: any) => {
    setCsTipoTelefoneEmEdicao(Number(value.key));

    form.setFieldsValue({
      tipoTelefone: value.children,
      csTpTelefone: value.key,
    });
  };

  const telefoneMask = async (isValue: any) => {
    form.setFieldsValue({
      nuTelefone: masktelefoneSemDdd(isValue)
    });
  };

  const maskDddTelefone = async (isValue: any) => {
    isValue = isValue + "";
    isValue = isValue.replace(/\D/g, ""); //Remove tudo o que não é dígito
    form.setFieldsValue({
      nuDddTelefone: isValue,
    });
  };

  const maskRamalTelefone = async (isValue: any) => {
    isValue = isValue + "";
    isValue = isValue.replace(/\D/g, ""); //Remove tudo o que não é dígito
    form.setFieldsValue({
      nuRamal: isValue,
    });
  };

  const columns = [
    {
      // width: 200,
      key: "2",
      title: "Telefone",
      dataIndex: "",
      render: (ITelefone: ITelefonePessoaFisica) => <>({ITelefone.nuDddTelefone}) {ITelefone.numeroTelefone ? ITelefone.numeroTelefone : masktelefoneSemDdd(ITelefone.nuTelefone)}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Ramal",
      dataIndex: "",
      render: (ITelefone: ITelefonePessoaFisica) => <>{ITelefone.nuRamal}</>,
    },
    {
      // width: 200,
      key: "4",
      title: "Tipo",
      dataIndex: "",
      render: (ITelefone: ITelefonePessoaFisica) => <>{ITelefone.tipoTelefone}</>,
    },
    {
      key: "5",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (ITelefone: ITelefonePessoaFisica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  form.setFieldsValue({
                    "idPessoaFisicaTelefone": ITelefone.idPessoaFisicaTelefone,

                    "csTpTelefone": ITelefone.csTpTelefone,
                    "tipoTelefone": ITelefone.tipoTelefone,

                    "nuDddTelefone": ITelefone.nuDddTelefone,
                    "nuTelefone": ITelefone.nuTelefone,
                    "nuRamal": ITelefone.nuRamal,
                  });
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  telefones.forEach(tel => {
                    if (tel === ITelefone) {
                      tel.statusReg = 1;
                      tel.touched = true;
                      tel.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      tel.emEdicao = false;
                    }
                  })
                  ITelefone.emEdicao = true;
                  if (ITelefone.csTpTelefone) setCsTipoTelefoneEmEdicao(ITelefone.csTpTelefone);

                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (ITelefone?.idPessoaFisicaTelefone && ITelefone?.idPessoaFisicaTelefone < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setTelefones(telefones.filter((telefone) => telefone !== ITelefone));
                }}
              />
            </div>

            <div style={{ display: (ITelefone?.idPessoaFisicaTelefone && ITelefone?.idPessoaFisicaTelefone > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (ITelefone?.statusReg === 1 || ITelefone?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    ITelefone.touched = true; // MARCA O REGISTRO ALTERADO.
                    ITelefone.statusReg = (ITelefone.statusReg === 1 ? 2 : 1);
                    setTelefones(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(telefone => {
                        if (telefone.idPessoaFisicaTelefone === ITelefone.idPessoaFisicaTelefone) {
                          return ITelefone;
                        } else {
                          return telefone;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (ITelefone?.statusReg === 1 || ITelefone?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    ITelefone.touched = true; // MARCA O REGISTRO ALTERADO.
                    ITelefone.statusReg = (ITelefone.statusReg === 1 ? 2 : 1);
                    setTelefones(pre => {
                      return pre.map(telefone => {
                        if (telefone.idPessoaFisicaTelefone === ITelefone.idPessoaFisicaTelefone) {
                          return ITelefone;
                        } else {
                          return telefone;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },

  ];

  return (
    // <Card title='Telefones' variant="borderless" style={{ width: "100%" }}>
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirTelefone"
        type="primary"
        shape="round"
        onClick={() => {
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirTelefone");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Telefone
      </Button>

      <>

        <Modal title="Telefone" open={exibirModalPfTelefone}
          style={{ top: 20 }}
          destroyOnHidden={true}
          onCancel={() => {
            setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
            controleDaGrid("cancelar");
            form.resetFields([
              "csTpTelefone",
              "tipoTelefone",
              "nuDddTelefone",
              "nuTelefone",
              "nuRamal",
            ]);
          }}
          closable={false}
          cancelText="Cancelar"
          cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

          onOk={() => {
            validarTelefone();
          }}
          okText={estadoModal === 3 ? "Alterar" : "Incluir"}
          okButtonProps={{ shape: "round", icon: <CheckOutlined /> }}
        >
          <Row>
            <Col xs={24} sm={16}>
              <Form.Item
                label="Tipo de Telefone"
                labelCol={{ span: 24 }}
                labelAlign="left"
                name="tipoTelefone"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "O Tipo de telefone é obrigatório",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Tipo'
                  onChange={(_, index) => {
                    handlerTipoTelefone(index);
                  }}
                >
                  {lista_tipoTelefone?.map((e: any) => (
                    <Option key={e.enum} value={e.enum} >
                      {e.tipoTelefone}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} sm={4}>
              <Form.Item label='DDD'
                name='nuDddTelefone'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Digite um DDD válido",
                  },
                ]}
              >
                <Input
                  onChange={(e) => maskDddTelefone(e.target.value)}
                  maxLength={3}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label='Telefone'
                name='nuTelefone'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'O campo telefone é obrigatório.',
                  },
                ]}
              >
                <Input
                  onChange={(e) => telefoneMask(e.target.value)}
                  maxLength={csTipoTelefoneEmEdicao > 10 ? 9 : 10}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={6}>
              <Form.Item label='Ramal'
                name='nuRamal'
                colon={false}
              >
                <Input
                  onChange={(e) => maskRamalTelefone(e.target.value)}
                  maxLength={5}
                />
              </Form.Item>
            </Col>
          </Row>

        </Modal>

      </>

      <Row style={{ display: exibirTelefoneCadastrado }}>
        <Col
          xs={24}
          sm={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" columns={columns} dataSource={telefones} pagination={false} />
        </Col>
      </Row>
      {/* </Card> */}
    </>
  )
};

export default PessoaFisicaTelefone;